import React from "react";
import { Icons } from "../../utils/icons";
import { Theme } from "../../utils/theme";
import Icon from "./Icon";
import styled from "styled-components";

interface CircleIconProps {
  color: keyof Theme["colors"];
  icon: keyof Icons;
  size?: number;
}
const CircleIcon: React.FC<CircleIconProps> = props => {
  return (
    <IconWrapper borderColor={props.color}>
      <Icon size={props.size || 30} icon={props.icon} fillColor={props.color} />
    </IconWrapper>
  );
};

const IconWrapper = styled.div<{ borderColor: keyof Theme["colors"] }>`
  display: flex;

  justify-content: center;
  align-items: center;
  border-radius: 100%;
  border-color: ${({ borderColor, theme }) => theme.colors[borderColor]};
  border-width: 6px;
  border-style: solid;

  padding: 0.3rem;

  svg {
    opacity: 1;
  }
`;

export default CircleIcon;
